<template>
  <picker-field :label="label" :display="display" :value="value" ref="picker" @open="onSearch">
    <div class="list">
      <div class="weui-cells">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="select(item)"
        >
          <div class="weui-cell__bd">
            <p>
              {{item.si_name}}
            </p>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
      </div>
    </div>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";

export default {
  components: {
    PickerField
  },
  props: {
    label: {
      type: String,
      default: "服务项目"
    },
    value: String,
    currency: {
      type: String,
      default: "RMB"
    }
  },
  data() {
    return {
      display: null,
      items: []
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.si_name);
      me.$emit("select", item);
      me.display = item.display || item.si_name;
      me.$refs.picker.close();
    },
    onSearch() {
      var me = this;
      me.$loading({
        url: "/api/sale/serveitem/list",
        params: {
          number: 1,
          size: 999999,
          mode: 'MAIN',
          condition: JSON.stringify({
            type: "condition",
            value: `si_statuscode='AUDITED' and si_currency='${me.currency}'`
          })
        }
      }).then(function(res) {
        if (res.success) {
          me.items = res.data ? res.data.list : [];
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    }
  }
};
</script>